import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-input-helper-text',
  standalone: true,
  imports: [CommonModule, TranslateModule, NgbTooltipModule],
  templateUrl: './input-helper-text.component.html',
  styleUrl: './input-helper-text.component.scss'
})
export class InputHelperTextComponent {
  @Input() helpText: string = '';
}
